module.exports = __webpack_public_path__ + "img/fengshimeng_pink.677c674a.png";